

















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditArticle from "./edit-article.vue";

class PageAuditArticleRequest extends PageRequest {
  keyword: string;
  classTypeId: number = 1;
  multiTypeName: string = "文章";
  parentId?: number;
  parentName: string = "上级分类";
  categoryId?: number;
  screenWidth: number = document.body.clientWidth;
  isAudit: boolean = false;
}

@Component({ components: { EditArticle } })
export default class AuditArticles extends AbpBase {
  //filters
  pagerequest: PageAuditArticleRequest = new PageAuditArticleRequest();
  editModalShow: boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];
  selectionIds: any = [];

  edit() {
    this.editModalShow = true;
  }
  //多级菜单选择关闭时操作
  visibleChange(isShow) {
    // if (!isShow) this.getpage()
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.categoryId = null;
    }
    this.$store.state.article.currentPage = 1;
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.article.list;
  }
  get loading() {
    return this.$store.state.article.loading;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("article/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("article/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    await this.$store
      .dispatch({
        type: "article/getCascader",
        data: { classTypeId: this.pagerequest.classTypeId }, //文章新闻
      })
      .then((result) => {
        this.data = this.$store.state.article.cascaders.items;
        debugger;
        this.getpage();
      });
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "article/getAll",
      data: this.pagerequest,
    });
    this.$Modal.remove();
  }
  handleSelect(selection, row) {}
  handleSelectionChange(selection) {
    this.selectionIds = [];
    if (selection.length > 0)
      selection.forEach((e) => {
        this.selectionIds.push(e.id);
      });
  }
  handleBatchCommand() {
    if (!this.selectionIds || this.selectionIds.length == 0) {
      this.$Message.warning("请选择至少一条数据");
      return;
    }
    this.$Modal.confirm({
      title: "操作提示",
      content: "<p>确定要执行审核操作吗?</p>",
      loading: true,
      onOk: () => {
        this.doBatchCommand();
      },
    });
  }
  async doBatchCommand() {
    await this.$store.dispatch({
      type: "article/auditedArticle",
      data: { articleIds: this.selectionIds },
    });
    this.getpage();
  }
  get pageSize() {
    return this.$store.state.article.pageSize;
  }
  get totalCount() {
    return this.$store.state.article.totalCount;
  }
  get currentPage() {
    return this.$store.state.article.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  columns = [
    { type: "selection", width: 60, key: "handle" },

    {
      title: "分类",
      width: 120,
      key: "categoryName",
    },
    {
      title: "标题",
      key: "title",
    },
    {
      title: "推荐",
      width: 70,
      render: (h: any, params: any) => {
        return h("span", params.row.isRecommend ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: "审核",
      width: 70,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isAudit ? "" : "red",
            },
          },
          params.row.isAudit ? "已审" : "待审"
        );
      },
    },
    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/inhome/" +
                  params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      width: 100,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.selectionIds.push(params.row.id);
                  await this.$store.dispatch({
                    type: "article/auditedArticle",
                    data: { articleIds: this.selectionIds },
                  });
                  await this.getpage();
                },
              },
            },
            "审核"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId
                  );
                  this.$store.commit("article/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.article.editArticle.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，第【" + (params.index + 1) + "】条记录吗？"
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "article/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  columns2 = [
    { type: "selection", width: 60, key: "handle" },

    {
      title: "标题",
      key: "title",
    },

    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/inhome/" +
                  params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      width: 100,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.selectionIds.push(params.row.id);
                  await this.$store.dispatch({
                    type: "article/auditedArticle",
                    data: { articleIds: this.selectionIds },
                  });
                  await this.getpage();
                },
              },
            },
            "审核"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId
                  );
                  this.$store.commit("article/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.article.editArticle.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，第【" + (params.index + 1) + "】条记录吗？"
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "article/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.$store.state.article.currentPage = 1;
    this.loadCascaders();
  }
}
